import { IComponentOptionsDialogProperties } from './IComponentOptionsDialogProperties.interface';

export interface IComponentOptionsProperties {
    properties: IComponentOptionsDialogProperties[];
}
